import React, { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './routes/Home';
import About from './routes/About';
import OurWorks from './routes/OurWorks';
import Contact from './routes/Contact';
import WhyChooseUs from "./routes/WhyChooseUs";
import AdminSitso from './routes/AdminSitso'; // ADD IMPORT

function App() {
  const [theme, setTheme] = useState(localStorage.getItem('vf-theme') || 'dark');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('vf-theme', theme);
  }, [theme]);

  return (
    <div className="app">
      <Navbar theme={theme} setTheme={setTheme} />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/our-works" element={<OurWorks />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/why-choose-us" element={<WhyChooseUs />} />
          {/* ADD SITSO ADMIN ROUTE */}
          <Route path="/sitso" element={<AdminSitso />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
